// src/components/MiniBingoBoard.jsx
import React from "react";

const getBallLetter = (num) => {
  if (num >= 1 && num <= 15) return "B";
  if (num >= 16 && num <= 30) return "I";
  if (num >= 31 && num <= 45) return "N";
  if (num >= 46 && num <= 60) return "G";
  if (num >= 61 && num <= 75) return "O";
  return "";
};

const MiniBingoBoard = ({ calledNumbers }) => {
  const letters = ["B", "I", "N", "G", "O"];
  const ranges = [
    { start: 1, end: 15 },
    { start: 16, end: 30 },
    { start: 31, end: 45 },
    { start: 46, end: 60 },
    { start: 61, end: 75 },
  ];

  const getNumberCellClasses = (num, isCalled) => {
    let classes =
      "w-full h-auto aspect-square flex items-center justify-center font-extrabold transition-all duration-500 ease-in-out font-digital";
    classes += " text-[10px] sm:text-[11px]";

    if (isCalled) {
      classes += " bg-red-600 text-white shadow-inner animate-[popAndRotate_0.5s_ease-in-out]";
    } else {
      classes += " bg-[#1A1A1A] text-[#CCCCCC]";
    }
    return classes;
  };

  return (
    <div className="bg-black rounded-lg shadow-xl border border-gray-700 p-1 w-[200px] sm:w-[280px] mx-auto text-center flex-shrink-0">
      {/* Add the animation keyframes */}
      <style>{`
        @keyframes popAndRotate {
          0% {
            transform: scale(0.8) rotate(-10deg);
            opacity: 0;
          }
          50% {
            transform: scale(1.1) rotate(360deg);
          }
          100% {
            transform: scale(1) rotate(0deg);
            opacity: 1;
          }
        }
      `}</style>

      <div className="grid grid-cols-5 gap-1 mb-2">
        {letters.map((letter) => (
          <div
            key={`mini-header-${letter}`}
            className="flex items-center justify-center font-extrabold text-[25px] text-red-600"
            style={{
              backgroundColor: '#FFFFFF',
              fontFamily: "'Digital-7 Mono', 'Courier New', monospace",
            }}
          >
            {letter}
          </div>
        ))}
      </div>

      <div
        className="grid grid-cols-5 gap-1"
        style={{
          fontFamily: "'Digital-7 Mono', 'Courier New', monospace",
        }}
      >
        {Array.from({ length: 15 }).map((_, rowIndex) => (
          <React.Fragment key={`mini-row-${rowIndex}`}>
            {letters.map((letter, colIndex) => {
              const num = ranges[colIndex].start + rowIndex;
              const isCalled = calledNumbers.includes(num);
              if (
                num >= ranges[colIndex].start &&
                num <= ranges[colIndex].end
              ) {
                return (
                  <div
                    key={`mini-num-${letter}-${num}-${isCalled}`}
                    className={getNumberCellClasses(num, isCalled)}
                    style={{
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                    }}
                  >
                    {num}
                  </div>
                );
              }
              return (
                <div
                  key={`mini-empty-${letter}-${rowIndex}`}
                  className="w-full h-auto aspect-square bg-[#1A1A1A]"
                ></div>
              );
            })}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default MiniBingoBoard;